import React from "react";

export default function WhatLocalization() {
  return (
    <div className="bg-darkBlue py-20">
      <div className="w-6/12 text-white flex-col mx-auto justify-center">
        <h1 className="font-extrabold text-4xl">
          What is <span className="text-lightBlue">Localization?</span>
        </h1>
        <div className="leading-loose font-light">

        <p className="pt-6">
          Localization refers to the adaptation of documents for foreign
          audiences. Sometimes a pure translation is all that is required, but
          when it comes to documents like marketing brochures, product
          information leaflets, blog posts and websites, then localization
          services can be extremely important.
        </p>
        <br />
        <p className="pt-6">
          The skill to localize lies in translating and localizing a document
          without changing its meaning. It's a skill that develops over time,
          which is why at Tomedes we always use experienced translators who
          understand the requirements and boundaries of professional
          localization services. Some of the most commonly required localization
          services these days are the translation and localization of software,
          video games and apps.
        </p>
        </div>
      </div>
    </div>
  );
}
